import { Tree } from 'react-complex-tree'

import { SlateContext } from '@tribeplatform/react-slate-kit/hooks'

import { useSlateEditor } from './slate-editor.hook.js'

export type SlateTreeProps = {
  id: string
}

export const SlateTree = ({ id: slateId }: SlateTreeProps) => {
  const slateProps = useSlateEditor(slateId)

  return (
    <SlateContext.Provider value={slateProps}>
      <Tree treeId={slateId} rootItem={slateId} treeLabel="Slate" />
    </SlateContext.Provider>
  )
}
